import { handleActions } from "redux-actions";
import {
  setCompanyRoles,
  setCompanyRolesLoading,
  setAdminOpenedNodes,
  setCompany,
  setCompanies,
  updateCompanyName,
  setGroups,
  setGroupsLoading,
  updateGroupName,
  setGroupsOpenedNodes,
  setBusinessNetwork,
  setWorkspaceOrderGroupCandidates,
  setWorkspaceOrderGroupCandidatesLoading,
} from "../../../../actions";

const defaultState = {
  company: {
    companyId: null,
    companyName: null,
    companies: [],
    usersRoles: [],
  },
  companyGroups: {
    openedNodes: [],
    groups: [],
    loading: false,
  },
  workspaceOrderGroupCandidates: {
    items: [],
    loading: false,
  },
  openedNodes: [],
  companyRoles: {
    roles: [],
    loading: false,
  },
  businessNetwork: [],
};

const updateGroupInTree = (groups, groupId, newName, newGroupLookup) => {
  return groups.map((group) => {
    if (group.groupId === groupId) {
      return { ...group, name: newName, groupLookup: newGroupLookup };
    }
    if (group.childGroups && group.childGroups.length > 0) {
      return {
        ...group,
        childGroups: updateGroupInTree(group.childGroups, groupId, newName, newGroupLookup),
      };
    }
    return group;
  });
};

export default handleActions(
  {
    [setCompanyRoles]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        companyRoles: { ...state.companyRoles, roles: items },
      };
    },
    [setCompanyRolesLoading]: (state, { payload }) => {
      const { loading } = payload;
      return {
        ...state,
        companyRoles: { ...state.companyRoles, loading },
      };
    },
    [setAdminOpenedNodes]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        openedNodes: items,
      };
    },
    [setCompany]: (state, { payload }) => {
      const { companyId, companyName, usersRights } = payload;
      return {
        ...state,
        company: {
          ...state.company,
          companyId,
          companyName,
          usersRights,
        },
      };
    },
    [setCompanies]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        company: {
          ...state.company,
          companies: items,
        },
      };
    },
    [setGroups]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        companyGroups: { ...state.companyGroups, groups: items },
      };
    },
    [setGroupsLoading]: (state, { payload }) => {
      const { loading } = payload;
      return {
        ...state,
        companyGroups: { ...state.companyGroups, loading },
      };
    },
    [setGroupsOpenedNodes]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        companyGroups: { ...state.companyGroups, openedNodes: items },
      };
    },
    [updateCompanyName]: (state, { payload }) => {
      const { companyId, newName } = payload;
      return {
        ...state,
        company: {
          ...state.company,
          companyName:
            state.company.companyId === companyId
              ? newName
              : state.company.companyName,
          companies: state.company.companies.map(company =>
            company.value === companyId
              ? { ...company, label: newName }
              : company
          ),
        },
      };
    },
    [updateGroupName]: (state, { payload }) => {
      const { groupId, newName, newGroupLookup } = payload;
      return {
        ...state,
        companyGroups: {
          ...state.companyGroups,
          groups: updateGroupInTree(state.companyGroups.groups, groupId, newName, newGroupLookup),
        },
      };
    },  
    [setBusinessNetwork]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        businessNetwork: items,
      };
    },
    [setWorkspaceOrderGroupCandidates]: (state, { payload }) => {
      const { items } = payload;
      return {
        ...state,
        workspaceOrderGroupCandidates: {
          ...state.workspaceOrderGroupCandidates,
          items,
        },
      };
    },
    [setWorkspaceOrderGroupCandidatesLoading]: (state, { payload }) => {
      const { loading } = payload;
      return {
        ...state,
        workspaceOrderGroupCandidates: {
          ...state.workspaceOrderGroupCandidates,
          loading,
        },
      };
    },
  },
  defaultState
);
